// import dependencies
import React, { useState } from "react";
import {Document, Page} from "react-pdf/dist/esm/entry.webpack";

// import styles and assets
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../utils/font-awesome";
import * as styles from "./styles/pdf-display.module.scss";

export default function NinasOrientacion({docFile, display}) {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function changePage(offset) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    if (display === "tall") {
        return(
            <div className={`${styles.docDisplay} ${styles.tall}`}>
                <Document file={docFile} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page pageNumber={pageNumber} />
                </Document>
                <div className={`${styles.overlayButtons} ${styles.tallButtons}`}>
                    <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
                        <FontAwesomeIcon icon={["fas", "arrow-left"]} />
                    </button>
                    <button type="button" disabled={pageNumber >= numPages} onClick={ nextPage}>
                        <FontAwesomeIcon icon={["fas", "arrow-right"]} />
                    </button>
                </div>
                <div className={styles.pageNums}>
                    <p>Página {pageNumber || (numPages ? 1 : '--')} de {numPages || '--'}</p>
                </div>
                <div className={styles.bottomButtons}>
                    <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
                        <FontAwesomeIcon icon={["fas", "arrow-left"]} /> Anterior
                    </button>
                    <button type="button" disabled={pageNumber >= numPages} onClick={ nextPage}>
                        Siguiente <FontAwesomeIcon icon={["fas", "arrow-right"]} />
                    </button>
                </div>
            </div>
        );
    } else if (display === "wide") {
        return(
            <div className={`${styles.docDisplay} ${styles.wide}`}>
                <Document file={docFile} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page pageNumber={pageNumber} />
                </Document>
                <div className={`${styles.overlayButtons} ${styles.wideButtons}`}>
                    <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
                        <FontAwesomeIcon icon={["fas", "arrow-left"]} />
                    </button>
                    <button type="button" disabled={pageNumber >= numPages} onClick={ nextPage}>
                        <FontAwesomeIcon icon={["fas", "arrow-right"]} />
                    </button>
                </div>
                <div className={styles.pageNums}>
                    <p>Página {pageNumber || (numPages ? 1 : '--')} de {numPages || '--'}</p>
                </div>
                <div className={styles.bottomButtons}>
                    <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
                        <FontAwesomeIcon icon={["fas", "arrow-left"]} /> Anterior
                    </button>
                    <button type="button" disabled={pageNumber >= numPages} onClick={ nextPage}>
                        Siguiente <FontAwesomeIcon icon={["fas", "arrow-right"]} />
                    </button>
                </div>
            </div>
        );
    }
}